import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import Autorizar from "@/pages/admin/Autorizar";
import { pageHead } from "@/lib/seo";

// Tela de conexão do Claude (OAuth do Painel da Clara): chega pela função painel-da-clara-oauth com o pedido na URL.
const busca = z.object({
  client_id: z.string().optional().catch(undefined),
  redirect_uri: z.string().optional().catch(undefined),
  code_challenge: z.string().optional().catch(undefined),
  state: z.string().optional().catch(undefined),
  scope: z.string().optional().catch(undefined),
  client_name: z.string().optional().catch(undefined),
});

const Pagina = () => <Autorizar busca={Route.useSearch()} />;

export const Route = createFileRoute("/admin/autorizar")({
  validateSearch: busca,
  head: () => pageHead({ title: "Conectar o Claude | Painel", path: "/admin/autorizar", noindex: true }),
  component: Pagina,
});
